import type { CSSProperties } from 'react'
import { CURRENT_CLIENT } from '@/constants'
import type { ClientWithLanding } from '@/landing/resolve-landing'

export const DEFAULT_MARKETING_CONTENT_MAX_WIDTH = 1200

export const DEFAULT_CINEMATIC_HERO_HEADLINE_CLASS = 'text-2xl sm:text-4xl md:text-5xl'

/**
 * Prefer margin gutters over padding so `--marketing-content-max-width` stays the true
 * content width. Side space is leftover from `max-width: min(1200px, 100% - gutters)`
 * plus `mx-auto` — not inset padding on the column.
 *
 * @deprecated Do not add horizontal padding wrappers. Use `MARKETING_CONTENT_COLUMN` alone.
 * Kept as an empty string so older call sites that still compose it are harmless.
 */
export const MARKETING_SHELL_X = ''

/**
 * Centered marketing column with margin gutters (16 / 24 / 32px).
 * Width is driven by `--marketing-content-max-width` (inline style).
 */
export const MARKETING_CONTENT_COLUMN_CLASS =
  'mx-auto w-full max-w-[min(var(--marketing-content-max-width,1200px),calc(100%-2rem))] sm:max-w-[min(var(--marketing-content-max-width,1200px),calc(100%-3rem))] lg:max-w-[min(var(--marketing-content-max-width,1200px),calc(100%-4rem))]'

export function resolveMarketingContentMaxWidth(
  client: ClientWithLanding = CURRENT_CLIENT as ClientWithLanding
): number {
  return client.landing?.chrome?.contentMaxWidth ?? DEFAULT_MARKETING_CONTENT_MAX_WIDTH
}

export function marketingContentColumnStyle(maxWidth?: number): CSSProperties {
  const w = maxWidth ?? resolveMarketingContentMaxWidth()
  return { '--marketing-content-max-width': `${w}px` } as CSSProperties
}

export function marketingContentColumnProps(maxWidth?: number): {
  className: string
  style: CSSProperties
} {
  return {
    className: MARKETING_CONTENT_COLUMN_CLASS,
    style: marketingContentColumnStyle(maxWidth),
  }
}

/** @deprecated Prefer `marketingContentColumnProps()` for className + style. */
export function marketingContentColumnClass(maxWidth?: number): string {
  return marketingContentColumnProps(maxWidth).className
}

export const MARKETING_CONTENT_COLUMN = MARKETING_CONTENT_COLUMN_CLASS
